<template>
  <div class="tl-db flex">
    <div :class="['flex-grow-1', bottomClass]" :style="[hasSidebarSlot ? 'max-width: 820px' : '']">
      <div :class="['tl-pr-0', hasSidebarSlot ? 'pr-50': '']">
        <slot name='upper'></slot>
        <h2 class="mb-30 fs-28" v-if="hasTitleSlot"><slot name='title'></slot></h2>
        <slot name='body'></slot>
      </div>
    </div>
    <div :class="['sidebar',bottomClass]" v-if='hasSidebarSlot' :style="[hasSidebarSlot ? 'max-width: 400px' : '']">
      <slot name='sidebar'></slot>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { DESKTOP } from '~/constant/common'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

export default {
  name: 'BodyRightSideBar',
  props: {
    bottomClass: {type: String, default: 'pb-60'}
  },
  setup(props, { slots }){
    const generalStore = useGeneralInfoStore()
    
    const windowWidth = computed(() => generalStore.generalData.windowWidth)
    const isDesktop = computed(() => windowWidth.value >= DESKTOP)
    const hasTitleSlot = computed(() => !!slots.title)
    const hasSidebarSlot = computed(() => !!slots.sidebar && isDesktop.value)

    return {
      hasTitleSlot, hasSidebarSlot
    }
  }
}
</script>

<style lang='scss' scoped>
  .sidebar {
    flex: 1 0 400px;
    position: relative;
  }
</style>
